// This file handles global cookies and scripts for third party services
// All other third party cookies and scripts are handled in their respective custom module
// Social Networks widget are handled in am_social_networks

function init() {
  void 0 === window._axcb && (window._axcb = []);
  window._axcb.push(function(axeptio) {
    axeptio.on("cookies:complete", function(choices) {
      if (choices.calameo) {
        launchCalameo()
      } else {
        hideCalameo()
      }

      if (choices.vimeo) {
        launchVideo('vimeo')
      } else {
        hideVideo('vimeo')
      }
      
      if (choices.youtube) {
        launchVideo('youtube')
      } else {
        hideVideo('youtube')
      }
      
      if (choices.google_analytics) {
        launchGA()
      }
    })
    axeptio.on("ready", function() {
      if (!axeptioCookieIsSet()) {
        hideAll()
      }
    })
  })

  document.addEventListener('click', (e) => {
    if (e.target && e.target.dataset.cookieConsent) {
      window.axeptioSDK.requestConsent(e.target.dataset.cookieConsent)
    } 
  })
}

function axeptioCookieIsSet() {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; axeptio_cookies=`);
  if (parts.length === 2) return true;
  return false;
}

function hideAll() {
  hideCalameo()
  hideVideo('youtube')
  hideVideo('vimeo')
}

function launchCalameo() {
  var elements = document.querySelectorAll('.calameo-player')
  elements.forEach(element => {
    var iframe = document.createElement('iframe');
    iframe.src = element.dataset.src;
    iframe.style = "margin:0 auto;";
    iframe.scrolling = "no";
    iframe.allowTransparency = "true";
    iframe.allow = "fullscreen";
    element.innerHTML = "";
    element.appendChild(iframe);
  })
}

function launchVideo(provider) {
  // .BookVideoTeaser-videoInModal, 
  var elements = document.querySelectorAll('.VideosPlayer-video--wrapper, .VidePlayer-playlist--video-hidden-iframe');
  elements.forEach(element => {
    if (element.dataset.iframe && element.dataset.iframe.search(provider) !== -1) {
      element.innerHTML = element.dataset.iframe;
    }
  })
}

function launchGA() {
  if (document.getElementById('gtmScript')) {
    return;
  }

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;j.id='gtmScript';f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-5M3XXZX');
}

function hideVideo(provider) {
  // .BookVideoTeaser-videoInModal, 
  var elements = document.querySelectorAll('.VideosPlayer-video--wrapper, .VidePlayer-playlist--video-hidden-iframe');
  elements.forEach(element => {
    if (element.dataset.iframe && element.dataset.iframe.search(provider) !== -1) {
      element.innerHTML = getConsentWarningHTML(provider);
    }
  })
}

function hideCalameo() {
  var elements = document.querySelectorAll('.calameo-player')
  elements.forEach(element => {
    element.innerHTML = getConsentWarningHTML('calameo');
  })
}

function getConsentWarningHTML(cookieName) {
  var html = `<div class="cookie-consent-warning">`;
  html += `<div>Vous devez autoriser les cookies ${cookieName} pour voir ce contenu.</div>`;
  html += `<button type="button" class="Button Button-square" data-cookie-consent="${cookieName}">Autoriser</button>`;
  html += `</div>`;
  return html;
}

export default { init, getConsentWarningHTML }
